import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { STATUS } from '@app/constants/commonConstants';
import Availability from '@app/components/common/Availability';

export const AvailabilityInformation = ({ loadingStatus, partNumber }) => {
  const isLoading = loadingStatus === STATUS.PENDING;
  const availability = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.availability
  );
  const quantity = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.quantity
  );
  const sourcingDetails = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.sourcingDetails
  );
  const catEntryId = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.itemCatEntryId
  );
  const hoseAvailabilityLabel = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.hoseAvailabilityLabel
  );
  const hoseAssemblyIndicator = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.hoseAssemblyIndicator
  );

  return (
    <Availability
      availabilityInformation={availability}
      sourcingDetailsInformation={sourcingDetails}
      catEntryId={catEntryId}
      hideLabel={true}
      isLoading={isLoading}
      quantity={quantity}
      hoseAssemblyDetails={{ hoseAvailabilityLabel, hoseAssemblyIndicator }}
    />
  );
};

AvailabilityInformation.propTypes = {
  loadingStatus: PropTypes.string,
  partNumber: PropTypes.string
};
